export const formsConfig = {
  config: {},
  statusFalse: {},
  statusTrue: {},
  ready: true,
  init() {
    if (!formsConfig.ready) return;
  },
};
